import { ApiResponse, SearchPaging, Vehicle } from 'models/model';
import fetchApi from './api';
import fetchApiBlob from './apiBlob';
const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL || '';


export const VehicleCreate = async (data: Vehicle): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/Vehicle/Create', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

export const VehicleUpdate = async (data: Vehicle): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/Vehicle/Update', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

export const VehicleDelete = async (id: string): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/Vehicle/Delete', {
        method: 'POST',
        body: JSON.stringify({ id })
    });
};

export const VehicleGet = async (id: string): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/Vehicle/Get', {
        method: 'POST',
        body: JSON.stringify({ id })
    });
};

export const VehicleGetPaging = async (searchPaging?: SearchPaging): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/Vehicle/GetPaging', {
        method: 'POST',
        body: JSON.stringify(searchPaging || {})
    });
};

export const VehicleImport = async (file: File): Promise<ApiResponse> => {
    const formData = new FormData();
    formData.append("File", file);
    return fetchApi<any>('/Vehicle/Import', {
        method: 'POST',
        body: formData,
        headers: {
            'Accept': 'application/json',
        }
    },);
};

export const VehicleDownloadTemplate = async (): Promise<Blob> => {
    return fetchApiBlob<any>('/Vehicle/Template', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        }
    });
};